export const messages = {
  appTitle: 'RAE',
  appLogoTitle: 'Route and schedule editor',
  traffic: 'Traffic Situation',
  feedback: 'Feedback Channel',
  train: 'Train Departures',
  digitraffic: 'Digitraffic',
  digitransit: 'Digitransit',
  nap: 'NAP',
  contact: 'Contact Information',
  contactLink: 'contact-information-and-invoicing-instructions',
  privacy: 'Privacy Policy',
  accessibility: 'Accessibility',
  rae: 'RAE - Route and schedule editor',
  about: 'About',
  instructions: 'RAE instructions',
  terms: 'Terms and conditions',
  support: 'Support',
  channels: 'Support channels',
  login: 'Log in',
  logout: 'Log out',
  register: 'Register',
  redirecting: 'Redirecting...',
  loginIntro: 'Log in to start using the service.',
  registerIntro: 'Create an account if you are new to the service.',
  shortcuts: 'Shortcuts',
  localeen: 'In English',
  localefi: 'Suomeksi',
  localesv: 'På Svenska',
  fintrafficApp: 'Fintraffic App',
  fintrafficAppLink: 'fintraffic_app',
  fintrafficMatka: 'Fintraffic Matka',
  fintrafficSky: 'Fintraffic Sky',
  landingPageIntroP1:
    'Route and Schedule Editor (RAE) is an editor managed by Fintraffic Oy, which can be used to digitize and store public transport routes and demand-responsive transport with stop chains and stop-specific schedules into NeTEx-format travel data.',
  landingPageIntroP2:
    'The routes published in the RAE tool form operator-specific travel data, which you can report as part of your travel data interfaces to the national access point {link} along with your other data. The data reported to the Finap is automatically added to the national Aggregation Service and thus to route planners. You can find more information about submitting data to the Finap on the instruction site.',
  landingPageIntroP3:
    'RAE is a so-called basic editor for essential information, intended for operators whose route and service offerings are not large (e.g., 1-20 routes to be maintained). In addition to route traffic, the tool can also model demand-responsive transport.',
};
